<template>
	<div id="sell-container">
		<b-container fluid>
			<!-- QUOTE -->
			<b-row class="py-5" style="background: url('images/vende/background.jpg'); background-size: cover">
				<b-container>
					<b-row>
						<b-col cols="12" md="8">
							<div class="d-none d-lg-block">
								<h1 class="text-macal"><b>Vende tu Auto Hoy</b></h1>
								<h4 class="my-0">
									Recibe el mejor precio del mercado y sin moverte de tu casa <br />
									<b>¡Tú no te mueves! Macal lo hace por ti</b>
								</h4>
								<p class="line-effect"></p>
								<b-table-simple class="mb-0" borderless>
									<b-tr>
										<b-td class="px-0" width="60px">
											<b-img src="images/vende/cotiza.png" ></b-img>
										</b-td>
										<b-td>
											<b class="text-macal">Cotiza Online</b><br />
											Cotiza tu auto en menos de 1 min y agéndate.
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="px-0" width="60px">
											<b-img src="images/vende/agenda.png" ></b-img>
										</b-td>
										<b-td>
											<b class="text-macal">Agenda tu inspección</b><br />
											Realiza tu inspección por videollamada en menos de 20 min y Macal se coordinará contigo para retirar el auto a tu casa.
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="px-0" width="60px">
											<b-img src="images/vende/recibe.png" ></b-img>
										</b-td>
										<b-td>
											<b class="text-macal">Recibe tu pago Inmediato</b><br />
											¡Listo! Obtendrás el pago de tu auto en menos de 1 hora una vez realizada la inspección virtual.
										</b-td>
									</b-tr>
								</b-table-simple>
							</div>
							<div class="d-lg-none text-center">
								<h2 class="text-macal"><b>Vende tu Auto Hoy</b></h2>
								<p>
									Recibe el mejor precio del mercado y sin moverte de tu casa <br />
									<b>¡Tú no te mueves! Macal lo hace por ti</b>
								</p>
								<b-table-simple class="mb-0" borderless>
									<b-tr>
										<b-td width="30%">
											<b-img src="images/vende/cotiza.png" ></b-img>
										</b-td>
										<b-td width="33%">
											<b-img src="images/vende/agenda.png" ></b-img>
										</b-td>
										<b-td width="36%">
											<b-img src="images/vende/recibe.png" ></b-img>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td style="line-height: 1rem;">
											<small><b class="text-macal">Cotiza Online</b></small>
										</b-td>
										<b-td style="line-height: 1rem;">
											<small><b class="text-macal">Agenda tu inspección</b></small>
										</b-td>
										<b-td style="line-height: 1rem;">
											<small><b class="text-macal">Recibe tu pago Inmediato</b></small>
										</b-td>
									</b-tr>
								</b-table-simple>
							</div>
						</b-col>
						<b-col cols="12" md="4">
							<b-form-group class="mb-0" description="Vehículos sin pérdida total y desde el 2014">
								<b-input-group class="mt-3">
									<b-form-input placeholder="Ingresa tu patente" v-model.trim="car.plate" :state="car.plateState" @keyup="uppercase" trim autocomplete="off"></b-form-input>
									<b-input-group-append>
										<b-button variant="macal" class="px-4" @click="searchByPlate"><font-awesome-icon :icon="['fal', 'search']" /></b-button>
									</b-input-group-append>
								</b-input-group>
							</b-form-group>
							<b-table-simple class="mb-0" borderless>
								<b-td>
									<p class="line-effect"></p>
								</b-td>
								<b-td width="1px" class="px-0">
									O
								</b-td>
								<b-td>
									<p class="line-effect"></p>
								</b-td>
							</b-table-simple>
							<b-card no-body class="bg-dark-grey px-4" style="border: none;">
								<b-table-simple borderless condensed small class="mt-4">
									<b-tr>
										<b-td class="text-right">
											<multiselect class="multiselect-sm" v-model.trim="$v.car.brand.$model" :options="brands" :close-on-select="true" :show-labels="false" :loading="loading.brand" placeholder="Marca" track-by="value" label="text" @input="updateBrandText">
												<template slot="noOptions">No hay marcas disponibles.</template>
											</multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.brand.required">Debes ingresar Marca.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<multiselect class="multiselect-sm"  v-model.trim="$v.car.year.$model" :loading="loading.year" :options="years" :close-on-select="true" :show-labels="false" placeholder="Año" track-by="value" label="text" @input="updateYearText">
												<template slot="noOptions">Debes seleccionar marca primero.</template>
											</multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.year.required">Debes ingresar Año.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right ">
											<multiselect class="multiselect-sm"  v-model.trim="$v.car.model.$model" :loading="loading.model" :options="models" :close-on-select="true" :show-labels="false" placeholder="Modelo" track-by="value" label="text" @input="updateModelText">
												<template slot="noOptions">Debes seleccionar año primero.</template>
											</multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.model.required">Debes ingresar Modelo.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<multiselect class="multiselect-sm"  v-model.trim="$v.car.version.$model" :loading="loading.version" :options="versions" :close-on-select="true" :show-labels="false" placeholder="Versión" track-by="value" label="text" @input="updateVersionText">
												<template slot="noOptions">Debes seleccionar modelo primero.</template>
											</multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.version.required">Debes ingresar Version.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<multiselect class="multiselect-sm" v-model="car.km" :options="kms" :close-on-select="true" :show-labels="false" placeholder="Kilometraje" track-by="value" label="text" @input="updateKmText"></multiselect>
											<div class="invalid-feedback d-block" v-if="submited && !$v.car.km.required">Debes ingresar Kilometraje.</div>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<b-form-input size="sm" placeholder="E-Mail" v-model.trim="$v.reservation.email.$model" :state="$v.reservation.email.$dirty ? !$v.reservation.email.$error : null"></b-form-input>
											<b-form-invalid-feedback id="input-1-live-feedback">
												Email inválido.
											</b-form-invalid-feedback>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-right">
											<b-form-input size="sm" placeholder="Teléfono" @keyup="addPlusToPhone" v-model.trim="$v.reservation.phone.$model" :state="$v.reservation.phone.$dirty ? !$v.reservation.phone.$error : null"></b-form-input>
											<b-form-invalid-feedback id="input-1-live-feedback">
												Número de teléfono incorrecto.
											</b-form-invalid-feedback>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-center">
											<b-form-group>
												<b-form-checkbox v-model.trim="$v.car.terms.$model" value="accepted" unchecked-value="not_accepted" :state="$v.car.terms.$dirty ? !$v.car.terms.$error : null" @change="car.termsState=null">
													Acepto los <a href="https://www.macal.cl/MiSitio/Asset/Docs/T%c3%a9rminos%20y%20condiciones%20Particulares%20Macal.pdf" target="_blank" style="text-decoration: underline;">Términos y condiciones</a>
													<b-form-invalid-feedback :state="car.termsState">Debes aceptar los términos y condiciones</b-form-invalid-feedback>
												</b-form-checkbox>
											</b-form-group>
											<b-form-invalid-feedback id="input-1-live-feedback">
												Debes Aceptar los términos y condiciones.
											</b-form-invalid-feedback>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-center">
											<vue-recaptcha ref="recaptcha" @verify="onVerify" :sitekey="captcha.sitekey"></vue-recaptcha>
										</b-td>
									</b-tr>
									<b-tr v-if="this.errors" >
										<b-td class="text-center">
											<b-alert class="" variant="danger" show>{{ errors }}</b-alert>
										</b-td>
									</b-tr>
									<b-tr>
										<b-td class="text-center">
											<b-button size="lg" class=" mt-2 px-5" variant="grey" @click="send">REVISA TU OFERTA</b-button>
										</b-td>
									</b-tr>
								</b-table-simple>
							</b-card>
						</b-col>
						<b-col cols="12">
							<b-col v-if="send_loading" cols="12" class="text-center mt-5">
								<grid-loader :color="color"></grid-loader>
							</b-col>
							<b-col md="12" class="captcha-element text-center mt-3" >

							</b-col>
						</b-col>
					</b-row>
				</b-container>
			</b-row>
			<!-- END QUOTE -->
			<v-section-white :top="false" :bottom="false" v-if="false">
				<b-row class="mt-5">
					<b-col class="text-center">
						<p class="section-header"><b>¡PROMOCIONES SOLO POR 3 DÍAS!</b></p>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col lg="8" offset-lg="2">
						<p class="section-subheader text-center">Oportunidades para tu venta</p>
					</b-col>
				</b-row>
				<v-carousel></v-carousel>
			</v-section-white>
			<v-section-grey :top="false" :bottom="false">
				<b-row class="mt-5">
					<b-col class="text-center">
						<p class="section-header"><b>¿POR QUÉ VENDER EN MACAL?</b></p>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col lg="8" offset-lg="2">
						<p class="section-subheader text-center">Conoce los beneficios de vender tu auto con nosotros</p>
					</b-col>
				</b-row>
			</v-section-grey>
			<v-section-grey :top="false">
				<b-row>
					<b-col md="4" offset-md="1" class="pl-0 d-none d-md-block">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<b-img src="images/vende/vende_1.svg" fluid ></b-img>
							</div>
						</div>
					</b-col>
					<b-col md="6" class="text-center">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<h2 class="pt-5 inline-block"><div class="step-number-macal">1</div></h2>
								<h3><b>EL MEJOR PRECIO, SIEMPRE</b></h3>
								<p class="mt-3 text-justify">
									Macal tiene los mejores precios de compra de todos los portales. Cotiza en 2 minutos y si tienes alguna duda, estamos a tu disposición.
								</p>
							</div>
						</div>
					</b-col>
				</b-row>
			</v-section-grey>
			<v-section-white>
				<b-row class="my-5">
					<b-col offset-md="1" md="6" class="text-center">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<h2 class="pt-5 inline-block"><div class="step-number-macal">2</div></h2>
								<h3><b>PAGAMOS AL INSTANTE</b></h3>
								<p class="mt-3 text-justify">
									Una vez efectuada la inspección de tu auto, recibe tu pago en tu cuenta bancaria.
								</p>
							</div>
						</div>
					</b-col>
					<b-col md="4" class="pr-0 d-none d-md-block">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<b-img src="images/vende/vende_2.svg" fluid ></b-img>
							</div>
						</div>
					</b-col>
				</b-row>
			</v-section-white>
			<v-section-grey>
				<b-row class="my-5">
					<b-col md="4" offset-md="1" class="pl-0 d-none d-md-block">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<b-img src="images/vende/vende_3.svg" fluid ></b-img>
							</div>
						</div>
					</b-col>
					<b-col md="6" class="text-center">
						<div class="d-table h-100 w-100">
							<div class="d-table-cell align-middle w-100 h-100">
								<h2 class="pt-5 inline-block"><div class="step-number-macal">3</div></h2>
								<h3><b>LO INSPECCIONAMOS EN TU CASA!</b></h3>
								<p class="mt-3 text-justify">
									Para tu comodidad podemos coordinar una <b>inspección en tu domicilio</b>, o recibirte en nuestras sucursales:
									<ul class="macal-ul">
										<li><b>Buenaventura:</b> Totoral 951, Quilicura</li>
										<li><b>Los Cobres de Vitacura:</b> Av. Vitacura 6710. Local A7</li>
									</ul>
								</p>
							</div>
						</div>
					</b-col>
				</b-row>
			</v-section-grey>
		</b-container>
		<v-sell-modal :openModal="openModal"></v-sell-modal>
		<b-modal id="modal-auction" show inner-class="modal-auction" title="" hide-header hide-footer>
			<b-container fluid>
				<h2 class="text-right">
					<a href="javascript:;" class="mt-3 mr-3" @click="$bvModal.hide('modal-auction')">X</a>
				</h2>
				<div class="text-center">
					<b-img src="images/icono.svg" height="50" alt="logo"/>
				</div>
				<b-row class="pt-4">
					<b-col>
						<p class="text-center text-macal">
							<span class="section-header">Próximo Remate</span><br />
							<b class="section-subheader" v-if="auction.auction_date">{{auction.auction_date | moment("utc", "DD-MM-YYYY HH:mm")}}</b>
						</p>
						<p class="text-center">Elige tu auto y abona tu garantía online para participar en el remate</p>
						<p class="text-center"><b-button size="lg" class="mt-4 mb-4 pl-5 pr-5" variant="outline-macal" :to="{ name: 'vehicles-home' }">Ver ofertas de autos</b-button></p>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>
	</div>
</template>

<script>
	import SectionWhite from "../../components/section-white";
	import SectionGrey from "../../components/section-grey";
	import SellModal from "./components/sell-modal";
	import Carousel from "../../components/carousel";
	import Multiselect from 'vue-multiselect';
	import {es} from 'vuejs-datepicker/dist/locale';
	import { required, minLength, maxLength, email } from "vuelidate/lib/validators";
	import VueRecaptcha from 'vue-recaptcha';
  export default {
	name: 'Index',
	components: {
		'v-section-white': SectionWhite,
		'v-section-grey': SectionGrey,
		'v-sell-modal': SellModal,
		'v-carousel': Carousel,
		Multiselect,
		VueRecaptcha
	},
	data(){
		return{
			auction: {url_ncr: ""},
			open: true,
			showQuote: this.open,
			sendableQuote: false,
			send_loading: false,
			es: es,
			setSchedule: false,
			captcha: {
				sitekey: process.env.VUE_APP_CAPTCHA_KEY,
				valid: false,
				error: false,
			},
            color: "#E4610C",
			car:{
				plate: '',
				brand: null,
				year: null,
				model: null,
				version: null,
				offer: null,
				terms: null,
				termsState: null,
				plateInvalidFeedback: null,
				plateState: null,
				km: null,
			},
			data: {
				brandText: '-',
				yearText: '-',
				modelText: '-',
				versionText: '-',
				kmText: '-'
			},
			plateData: {
				brand: null,
				year: null,
				model: null,
				version: null
			},
			loading: {
				brand: false,
				year: false,
				model: false,
				version: false,
			},
			errors: '',
			hour: "",
			date: "",
			brands: [],
			years: [],
			models: [],
			versions: [],
			kms: [
				{ value: 5000, text: "5.000" },
				{ value: 10000, text: "10.000" },
				{ value: 20000, text: "20.000" },
				{ value: 30000, text: "30.000" },
				{ value: 40000, text: "40.000" },
				{ value: 50000, text: "50.000" },
				{ value: 60000, text: "60.000" },
				{ value: 70000, text: "70.000" },
				{ value: 80000, text: "80.000" },
				{ value: 90000, text: "90.000" },
				{ value: 100000, text: "100.000" },
				{ value: 150000, text: "150.000" },
				{ value: 200000, text: "200.000" },
			],
			dateState: {
				disabled: {
					to: new Date,
					from: new Date,
				},
				highlighted: {}
			},
			branch_id: null,
			dateTitle: null,
			hourTitle: null,
			branches: null,
			hours: [],
			reservation: {
				date: null,
				hour: null,
				quote_id: null,
				inspector_id: null,
				branch_id: null,
				name: null,
				lastname: null,
				email: null,
				phone: null,
				"g-recaptcha-response": ""
			},
			phone_reservation:{
				name: "",
				lastname: ""
			},
			submited: false,
		}
	},
	validations: {
		car:{
			brand: { required },
			year: { required },
			model: { required },
			version: { required },
			km: { required },
			terms: { required },
		},
		reservation: {
			phone: {required, minLength: minLength(12), maxLength: maxLength(12)},
			email: {required, email},
		},
		phone_reservation: {
			name: {required, minLength: minLength(3)},
			lastname: {required, minLength: minLength(3)},
		}
	},
	computed: {
		"car.plate": {
			get () { return this.car.plate },
			set (text) { this.car.plate = text.toUpperCase()}
		}
	},
	beforeMount(){
		const cur = this;
		this.axios.get("auctions/next").then(result => {
			if(typeof result.data.length != undefined){
				cur.auction = result.data;
			}
		}).catch(() => {
		})
	},
	mounted() {
		this.$moment.locale('es');
		this.amount= this.price;
		this.setBrand();
		if(this.openModal){
			this.$bvModal.show('modal-sell');
		}
	},
	props: {
		openModal: {default: false}
	},
	watch: {
		openModal: {
			handler: function(search) {
				if(search){
					this.$bvModal.show('modal-sell');
				}
			},
			deep: true,
			immediate: true
		},
		"open": {
			handler: function() {
				this.showQuote = this.open;
			}
		}
	},
	methods: {
		showModal() {
			this.$refs['modal-sell'].show()
		},
		scrollFromHead() {
			window.scroll({
				top: document.querySelector('.scroll-receiver').offsetTop - 150,
				behavior: 'smooth'
			});
			//	document.querySelector('.scroll-receiver').scrollIntoView({
			//		behavior: 'smooth'
			//	});
		},
		scrollToQuote() {
			this.open = true;
			window.scroll({
				top: document.querySelector('.car-quote').offsetTop - 250, 
				behavior: 'smooth'
			});
		},
		addPlusToPhone(){
			if(this.reservation.phone !== null){
				this.reservation.phone = '+'+this.reservation.phone.replace(/[|&;$%@"<>()+a-zA-Z,]/g,"");
			}
		},
		validateConfirmData(){
			this.$v.phone_reservation.$touch()
			this.$v.reservation.$touch()
			if(!this.$v.phone_reservation.$invalid && !this.$v.reservation.$invalid) this.showConfirmData = true
		},
		onVerify: function (response) {
			if(response.length > 0){
				this.captcha.valid = true
				this.captcha.error = false
				this.reservation["g-recaptcha-response"] = response
			}
		},
		uppercase(){
			this.car.plate = this.car.plate.toUpperCase()
		},
		searchByPlate(){
			const cur = this;
			cur.showQuote = true;
			if(this.car.plate.length > 0){
				cur.loading.year = true;
				cur.loading.model = true;
				cur.loading.version = true;
				this.axios.get("cars/search_by_plate", {params: {plate: this.car.plate}}).then(result => {
					cur.car.plateInvalidFeedback = null
					cur.car.plateState = null
					cur.plateData.brand = { value: result.data.brand_id, text: result.data.brand}
					cur.plateData.year = { value: result.data.year_id, text: result.data.year}
					cur.plateData.model = { value: result.data.model_id, text: result.data.model}
					cur.plateData.version = { value: result.data.version_id, text: result.data.version}
					cur.car.brand = cur.plateData.brand;
					cur.data.brandText = cur.plateData.brand.text;
					cur.setYear();
				}).catch(() => {
					cur.car.plateInvalidFeedback = "Patente no entontrada"
					//cur.car.plateState= false
					cur.$store.commit('hideLoading');
					cur.loading.year = false;
					cur.loading.model = false;
					cur.loading.version = false;
					cur.car.brand = null;
					cur.cleanYear();
					cur.cleanModel();
					cur.cleanVersion();
				})
			}

		},
		updateBrandText(event) {
			this.$v.car.$touch()
			this.data.brandText = event.text;
			this.loading.year = true;
			this.setYear();
			this.cleanModel();
			this.cleanVersion();
		},
		updateYearText(event) {
			this.data.yearText = event.text;
			this.loading.model = true;
			this.setModel();
			this.cleanVersion();
		},
		updateModelText(event) {
			this.data.modelText = event.text;
			this.loading.version = true;
			this.setVersion();
		},
		updateVersionText(event) {
			this.data.versionText = event.text;
		},
		updateKmText(event) {
			this.data.kmText = event.text;
		},
		changeStep(value) {
			this.step = value;
		},
		changeBrand(elem) {
			this.car.brand = elem;
			this.updateBrandText(elem);
		},
		setBrand(){
			const cur = this;
			cur.loading.brand = true;
			this.axios.get("cars/get_sell_brands")
			.then(result => {
				cur.loading.brand = false;
				cur.brands = result.data;
			})
			.catch(() => {
				cur.loading.brand = false;
				cur.$store.commit('hideLoading');
			})
		},
		setYear(){
			this.cleanYear();
			const cur = this;
			cur.loading.year = true;
			this.axios.get("cars/get_sell_years", {params: {brand_id: this.car.brand.value}}).then(result => {
				cur.loading.year = false;
				cur.years = result.data;
				if(cur.plateData.year){
					cur.car.year = cur.plateData.year;
					cur.data.yearText = cur.plateData.year.text;
					cur.setModel();
				}
			}).catch(() => {
				cur.loading.year = false;
				cur.$store.commit('hideLoading');
			})
		},
		setModel(){
			this.cleanModel();
			const cur = this;
			cur.loading.model = true;
			this.axios.get("cars/get_sell_models", {params: {brand_id: this.car.brand.value, year_id: this.car.year.value}})
			.then(result => {
				cur.loading.model = false;
				cur.models = result.data;
				if(cur.plateData.model){
					cur.car.model = cur.plateData.model;
					cur.data.modelText = cur.plateData.model.text;
					cur.setVersion();
				}
			})
			.catch(() => {
				cur.loading.model = false;
				cur.$store.commit('hideLoading');
			})
		},
		setVersion(){
			this.cleanVersion();
			const cur = this;
			cur.loading.version = true;
			this.axios.get("cars/get_sell_versions", {params: {brand_id: this.car.brand.value, year_id: this.car.year.value, model_id: this.car.model.value}})
			.then(result => {
				cur.loading.version = false;
				cur.versions = result.data;
				if(cur.plateData.year){
					cur.car.version = cur.plateData.version;
					cur.data.versionText = cur.plateData.version.text;
				}
				cur.resetPlateData();
			})
			.catch(() => {
				cur.loading.version = false;
				cur.$store.commit('hideLoading');
			})
		},
		cleanYear(){
			this.years= []
			this.car.year = null;
			this.data.yearText = "-";
		},
		cleanModel(){
			this.models = []
			this.car.model = null;
			this.data.modelText = "-";
		},
		cleanVersion(){
			this.versions = []
			this.car.version = null;
			this.data.versionText = "-";
		},
		resetPlateData(){
			this.plateData.brand = null;
			this.plateData.year = null;
			this.plateData.model = null;
		},
		send(){
			this.$v.car.$touch()
			this.$v.reservation.$touch()
			this.submited = true
			if(!this.$v.car.$invalid && !this.$v.reservation.$invalid){
				if(this.captcha.valid){
					const cur = this;
					cur.send_loading = true
					this.axios.post("sells/quote", {car: this.car, user: { email: this.reservation.email, phone: this.reservation.phone, "g-recaptcha-response": this.reservation["g-recaptcha-response"] }}).then(result => {
						//cur.car.offer = (result.data.Cotizacion.precio).toLocaleString('es');
						//cur.reservation.quote_id = result.data.Cotizacion.idCotizacion;
						//cur.branches = result.data.Sucursales;
						//cur.$v.reservation.$reset();
						cur.submited = false;
						cur.send_loading = false;
						cur.errors = "";
						window.location.href = result.data.LinkRedireccion;
						//cur.$router.push({ name: 'vehicles-sell-quote-response', params: {branches: cur.branches, data: cur.data, car: cur.car, reservation: cur.reservation}});
					})
					.catch(error => {
						cur.send_loading = false
						this.errors = error.data.data
					})
				}else{
					this.errors = "Debe validar captcha"
				}
			}
		}

	}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.multiselect--active{ z-index: 1030 }
	.multiselect__content-wrapper{ z-index: 1030 }
	@media (min-width: 991px){
		#sell-container{
			margin-top: 100px;
		}
	}
	#modal-sell___BV_modal_outer_{
		z-index: 1060 !important;
	}
	#sell-container .multiselect-sm {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
	}
	#sell-container .multiselect-sm .multiselect__tags {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		color: #35495e;
		padding: 0.25rem 0.5rem !important;
	}
	#sell-container .multiselect-sm .multiselect__select {
		height: 30px;
		font-size: 0.875rem !important;
		min-height: calc(1.5em + 0.5rem + 2px) !important;
		max-height: calc(1.5em + 0.5rem + 2px) !important;
		padding: 0.25rem 0.5rem !important;
	}
	#sell-container .multiselect-sm .multiselect__spinner{
		height: 28px;
	}
	.line-effect {background: #000; height:1px; margin-top:10px;}
	.line-effect span{background: #fff; padding:10px; position:relative; top:-10px; left: 20px}
</style>